onDomReady(function() {
   if (App.FrameModules) {
      FrameModules.execute();
   }
});

export var FrameModules = (window.FrameModules = {
   _dynamicModules: {
      CommentsFrameModule: async () => {
         const { initCommentsFrameModule } = await import(
            '../../../Guide/UI/templates/js/FrameModules/comments.js'
         );
         initCommentsFrameModule();
      },
      MessageUserFrameModule: async () => {
         const { MessageUser } = await import(
            '../../../Guide/UI/templates/js/FrameModules/comments.js'
         );
         MessageUser.initialize();
      },
   },

   _modules: {},

   add: function(name, fn) {
      // Push the framemodule javascript onto the queue to be executed only
      // when the FrameModule is included on the page.
      this._modules[name] = fn;
   },

   execute: function() {
      var self = this;
      App.FrameModules.each(function(name) {
         if (name in self._dynamicModules) {
            self._dynamicModules[name]();
         } else if (name in self._modules) {
            self._modules[name]();
         }
      });
   },
});
